module.exports = __webpack_public_path__ + "static/media/branch.dd7ba26e.svg";